import { render, staticRenderFns } from "./ImportSalary.vue?vue&type=template&id=358f42c2&scoped=true"
import script from "./ImportSalary.vue?vue&type=script&lang=js"
export * from "./ImportSalary.vue?vue&type=script&lang=js"
import style0 from "./ImportSalary.vue?vue&type=style&index=0&id=358f42c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358f42c2",
  null
  
)

export default component.exports